export default "__VITE_ASSET__Dokxrisq__"